import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
@Injectable({
  providedIn: 'root'
})

export class UserService {

  constructor( 
              private _clienteHttp:HttpClient 
            ){}
  public guardar(){
    return this._clienteHttp.get('https://my-json-server.typicode.com/typicode/demo/posts')
  }
}
